import { useState } from 'react';
import styles from './AlertBanner.module.css';

interface AlertBannerProps {
  text: string;
  linkUrl?: string | null;
  linkLabel?: string | null;
  variant: 'INFO' | 'WARNING' | 'PROMO';
  onDismiss: () => void;
}

type AlertBannerVariant = 'INFO' | 'WARNING' | 'PROMO';

const variantClass: Record<AlertBannerVariant, string> = {
  INFO: styles.info,
  WARNING: styles.warning,
  PROMO: styles.promo,
};

export const AlertBanner = ({
  text,
  linkUrl,
  linkLabel,
  variant,
  onDismiss,
}: AlertBannerProps) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    // Wait for CSS transition to finish
    setTimeout(onDismiss, 350);
  };

  return (
    <div
      className={`${styles.banner} ${variantClass[variant] || styles.info} ${closing ? styles.bannerDismissed : ''}`}
      role="alert"
      aria-live="polite"
    >
      <span className={styles.text}>
        {text}
        {linkUrl && linkLabel && /^https?:\/\//.test(linkUrl) && (
          <>
            {' '}
            <a
              href={linkUrl}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkLabel}
            </a>
          </>
        )}
      </span>
      <button
        className={styles.closeBtn}
        onClick={handleClose}
        aria-label="Dismiss banner"
      >
        &times;
      </button>
    </div>
  );
};
